import React, { useCallback, useState } from 'react';

import ActionModal from 'components/actionModal/ActionModal';
import CorporateIcon from 'components/icons/CorporateIcon';

import CorporateAccountContextProvider from '../context/CorporateAccountContext';
import { AccountCategory, AccountModalWindowStages } from '../models';

import CreateCorporateModal from './corporateAccounts/CreateCorporateModal';

export const dataForSelectingCategory = [
  {
    name: 'Group account',
    text: 'Organisations with prearranged sales agreements to onboard multiple users.',
    category: AccountCategory.Group,
    icon: <CorporateIcon />,
  },
];

type CreateAccountModalProps = {
  closeModalWindow: () => void;
};

const CreateAccountModal = ({ closeModalWindow }: CreateAccountModalProps) => {
  const [isNavbarTitleShown, setIsNavbarTitleShown] = useState(false);
  const [activeCategory, setActiveCategory] = useState(AccountCategory.Group);
  const [activatedCorporateStages, setActivatedCorporateStages] = useState([
    AccountModalWindowStages.SelectType,
  ]);

  const showNavbarTitle = useCallback(
    (value: boolean) => setIsNavbarTitleShown(value),
    []
  );

  const changeActiveCategory = useCallback(
    (category: AccountCategory) => setActiveCategory(category),
    []
  );

  const addNewStageToActivatedCorporate = useCallback(
    (stage: AccountModalWindowStages, disable?: boolean) => {
      if (disable) {
        setActivatedCorporateStages(activatedCorporateStages);

        return;
      }
      if (!activatedCorporateStages.includes(stage)) {
        setActivatedCorporateStages([...activatedCorporateStages, stage]);
      }
    },
    [activatedCorporateStages]
  );

  return (
    <CorporateAccountContextProvider>
      <ActionModal closeModalWindow={closeModalWindow}>
        {activeCategory === AccountCategory.Group && (
          <CreateCorporateModal
            isNavbarTitleShown={isNavbarTitleShown}
            activatedStages={activatedCorporateStages}
            closeModalWindow={closeModalWindow}
            showNavbarTitle={showNavbarTitle}
            setActiveCategory={changeActiveCategory}
            setActivatedStages={addNewStageToActivatedCorporate}
          />
        )}
      </ActionModal>
    </CorporateAccountContextProvider>
  );
};

export default CreateAccountModal;
